module.exports = __webpack_public_path__ + "img/ec_private2.e9d40f3c.svg";